import { render, staticRenderFns } from "./SetupVM.vue?vue&type=template&id=49f94ad8&"
import script from "./SetupVM.vue?vue&type=script&lang=js&"
export * from "./SetupVM.vue?vue&type=script&lang=js&"
import style0 from "./SetupVM.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports